import { Box, CardMedia, SxProps, Theme, useTheme } from '@mui/material';
import Search from './components/Search';
import check_icon from '@/assets/icons/home/maps/check.svg'

const TopBar = ({ displaySearch = true, sx }: { displaySearch?: boolean, sx?: SxProps<Theme> }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        position: 'absolute',
        left: { xs: '6px', md: '14px' },
        top: { xs: '6px', md: '14px' },
        zIndex: 2,
        display: 'flex',
        width: '100%'
      }}
    >
      <Box
        sx={{
          border: '0.5px solid rgba(0, 0, 0, 0.1)',
          width: { xs: '11px', md: '19px', lg: '27px' },
          height: { xs: '11px', md: '19px', lg: '27px' },
          borderRadius: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: theme.palette.common.white,
          boxSizing: 'border-box',
          marginRight: { xs: '7px', md: '9px', lg: '12px' },
          ...sx
        }}
      >
        <CardMedia 
          component='img'
          image={check_icon}
          sx={{
            width: { xs: '6px', md: '9px', lg: '13px' },
            height: { xs: '6px', md: '9px', lg: '13px' }
          }}
        />
      </Box>
      {displaySearch ? (
        <Search />
      ) : null}
    </Box>
  )
};

export default TopBar;